import { __assign } from './../../vendor/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from 'classnames';
import styles from './Icon.module.css.js';

var Icon = function (_a) {
    var children = _a.children, ariaLabel = _a.ariaLabel, className = _a.className, _b = _a.size, size = _b === void 0 ? 'small' : _b;
    var accessibilityProps = ariaLabel
        ? { 'aria-label': ariaLabel.toString(), role: 'img' }
        : { 'aria-hidden': true };
    var classes = classNames(styles.root, styles["icon-".concat(size)], className);
    return (React__default.createElement("i", __assign({ className: classes }, accessibilityProps), children));
};

export { Icon };
//# sourceMappingURL=Icon.js.map
